module.exports = __webpack_public_path__ + "media/images/flags/PG-3ce0687a4dcee2d1abf889e517141c02.svg";